
import { Base } from '../base-component';
import Slider from '../slider/slider.component';
import { MediaQueryService } from '../../services/media-query.service';

import './carousel.component.scss';



export class Carousel extends Base {

	sliderContainer: Element;
	sliderPagination: Element;
	sliderConfig: SwiperOptions;
	sliderNext: Element;
	sliderPrev: Element;
	windowWidth: number;
	sliderItems: number;
	breakpoints: {};

	constructor(element: Element) {
		super(element);
	}

	init() {
		this.sliderItems = Number(this.element.getAttribute('data-items'));
		this.sliderContainer = this.element.querySelector('.swiper-container');
		this.sliderPagination = this.element.querySelector('.swiper-pagination');
		this.sliderNext = this.element.querySelector('.swiper-button-next');
		this.sliderPrev = this.element.querySelector('.swiper-button-prev');
		this.windowWidth = document.documentElement.clientWidth;

		switch (this.sliderItems) {
			case 1:
				this.breakpoints = {};
				break;
			case 2:
				this.breakpoints = {
					576: {
						initialSlide: 0,
						slidesPerView: 1,
						spaceBetween: 15,
					}
				};
				break;
			default:
				this.breakpoints = {
					1200: {
						initialSlide: 0,
						slidesPerView: 3,
						spaceBetween: 30,
					},
					768: {
						initialSlide: 0,
						slidesPerView: 2,
						spaceBetween: 20,
					},
					576: {
						initialSlide: 0,
						slidesPerView: 1,
						spaceBetween: 15,
					}
				};
				break;
		}

		this.sliderConfig = {
			slidesPerView: this.sliderItems,
			spaceBetween: 30,
			initialSlide: 0,
			breakpoints: this.breakpoints,
			pagination: {
				el: this.sliderPagination,
				type: 'bullets',
				clickable: true
			},
			navigation: {
				nextEl: this.sliderNext,
				prevEl: this.sliderPrev,
			}
		};

		Slider.init(this.sliderContainer, this.sliderConfig);

	}

	bindEvents() { }

}



// WEBPACK FOOTER //
// ./components/carousel/carousel.component.ts